export default __webpack_public_path__ + "static/media/logo.68e9fa90.svg";